function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ThunkHelper from 'invision-core/src/api/thunk.helper';
import { LANGUAGE_HEADER } from 'invision-core/src/api/constants';
import values from 'ramda/src/values';
import { INITIAL_STATE } from '../recoverableUiState/contracts.list.reducer';
export var SET_CONTRACTS_SEARCH_CRITERIA = 'SET_CONTRACTS_SEARCH_CRITERIA';
export var resetSearchCriteria = function resetSearchCriteria() {
  return function (dispatch) {
    return dispatch({
      type: SET_CONTRACTS_SEARCH_CRITERIA,
      payload: INITIAL_STATE.searchCriteria
    });
  };
};
export var SEARCH_CONTRACT_EVENTS = {
  BEGIN: 'SEARCH_CONTRACTS_BEGIN',
  SUCCESS: 'SEARCH_CONTRACTS_SUCCESS',
  FAILURE: 'SEARCH_CONTRACTS_FAILURE'
};
var searchContractsPromise = function searchContractsPromise(dispatch, searchCriteria) {
  return ThunkHelper(dispatch, values(SEARCH_CONTRACT_EVENTS), {
    method: 'post',
    url: 'SubscriberManagement/SearchOrderContracts',
    headers: _defineProperty({}, LANGUAGE_HEADER, ''),
    data: searchCriteria
  });
};
export var searchContracts = function searchContracts(searchCriteria) {
  return function (dispatch) {
    return searchContractsPromise(dispatch, searchCriteria);
  };
};
export var setSearchCriteriaAndSearchContracts = function setSearchCriteriaAndSearchContracts(searchCriteria) {
  //TODO: this is a temporary solution until paging is supported on the modal in ASC-89791
  var searchCriteriaForcePageSizeOneThousand = Object.assign({}, searchCriteria, {
    PageSize: 1000
  });
  return function (dispatch) {
    dispatch({
      type: SET_CONTRACTS_SEARCH_CRITERIA,
      payload: searchCriteriaForcePageSizeOneThousand
    });
    return searchContractsPromise(dispatch, searchCriteriaForcePageSizeOneThousand);
  };
};